var li 	     = document.createElement('li');
var cart_detail = '';
var cart = document.getElementById("btn");

// for Items Ajax Call 
cart.onclick = (ev)=> {
  	console.log('hello, world bug');
	var xhttp = new XMLHttpRequest();
  	xhttp.onreadystatechange = function() {
    	
      	if (this.readyState == 4 && this.status == 200) {
     	
          cart_detail =  JSON.parse(this.responseText);
          
          editCart();  
          
         
    }
  };
  
  xhttp.open("GET", "https://fake-l.myshopify.com/cart.js", true);
  xhttp.send();
 
  
 
}



 
function editCart(){
	
  console.log(cart_detail.item_count);
  
  var   total_product = cart_detail.item_count,
  		products = cart_detail.items;
 
  products.forEach((el)=> {  
 	
    let img = el.image,title =el.title,number = el.quantity,price = el.price;
    
    document.querySelector('.collections').appendChild(document.createElement('li')); 
      	
      	
  })
  console.log("hello, world");
 document.querySelector('.collections').appendChild('li');
 
}